module.exports = __webpack_public_path__ + "img/catherine-church.28c010f3.jpg";